module.exports = __webpack_public_path__ + "static/media/ktb com.df3d2ce4.png";